import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
export var btrInfoMessageCard = /*#__PURE__*/css("background-color:", tokens.colors.accentThree.subdued.default, ";");
export var btrInfoMessageCardContent = /*#__PURE__*/css("display:flex;align-items:center;gap:10px;", designTokenFonts.body, ";");
export var btrInfoMessageFindOutMoreButton = /*#__PURE__*/css("color:", tokens.colors.accentThree.base.default, ";padding:0;min-height:auto;text-decoration:underline;");
export var btrInfoMessageBold = /*#__PURE__*/css(designTokenFonts.bodyBold, ";");
export var btrInfoMessageIcon = /*#__PURE__*/css("color:", tokens.colors.accentThree.base.default, ";");
export var btrModalContents = {
  name: "zwiamn",
  styles: "margin:20px;"
};
export var btrModalSection = {
  name: "1xaekgw",
  styles: "margin-top:20px;"
};
export var btrModalSectionVP = {
  name: "wspcyg",
  styles: "padding:10px 20px;li{margin-left:20px;list-style:disc;}"
};